import { inject } from '@angular/core';
import { Router, CanActivateFn } from '@angular/router';
import { GithubService } from '../features/services/github-service.service';
import { UserService } from '../services/user/user.service';

export const adminGuard: CanActivateFn = async (route, state) => {
  const _userService = inject(UserService);
  const router = inject(Router);

  try {
    // Wait for PRID to be available
    if (!_userService.prid) {
      console.warn('PRID not available yet, waiting...');
      await new Promise((resolve) => setTimeout(resolve, 500));
    }

    // If after waiting there's still no PRID, redirect
    if (!_userService.prid) {
      console.warn('PRID still not available, redirecting to login');
      router.navigate(['/auth/login']);
      return false;
    }

    const users = await _userService.fetchUser();
    const user = users;

    if (user && user.userType === 'admin') {
      return true;
    }

    console.warn('Access denied: User is not an admin');
    router.navigate(['/guadalajara']);
    return false;
  } catch (error) {
    console.error('Error checking admin access:', error);
    router.navigate(['/guadalajara']);
    return false;
  }
};
